"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUnitAwareNumber = isUnitAwareNumber;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// We don't expose mathjs to outside the mapistry-shared,
// If you need mathjs types, export from this file.
function isUnitAwareNumber(term) {
  if (_typeof(term) !== 'object' || term === null) return false;
  return 'value' in term && typeof term.value === 'number' && 'unit' in term && typeof term.unit === 'string';
}